import { render, staticRenderFns } from "./AcceptanceReceiptDialog.vue?vue&type=template&id=18dfb6e1&scoped=true"
import script from "./AcceptanceReceiptDialog.vue?vue&type=script&lang=js"
export * from "./AcceptanceReceiptDialog.vue?vue&type=script&lang=js"
import style0 from "./AcceptanceReceiptDialog.vue?vue&type=style&index=0&id=18dfb6e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfb6e1",
  null
  
)

export default component.exports